import { z } from 'zod';

const SUPER_CARD_STATUSES = [
  'NOT_STARTED',
  'IN_PROGRESS',
  'SUBMITTED',
  'UNDER_REVIEW',
  'APPROVED',
  'DECLINED',
  'PREQUALIFIED',
  'NEEDS_MORE_INFO',
] as const;

const SUPER_CARD_MODES = ['application', 'approved_portal'] as const;

// Coerce numeric strings so a stringly-typed count still parses.
function toNumber(value: unknown): unknown {
  return typeof value === 'string' && value.trim() ? Number(value) : value;
}

export type SuperCardDTO = z.infer<typeof superCardSchema>;
export const superCardSchema = z.object({
  has_access: z.boolean().nullable().default(false),
  has_access_for_apply: z.boolean().nullable().default(false),
  has_view_access: z.boolean().nullable().default(false),
  has_manage_access: z.boolean().nullable().default(false),
  status: z.enum(SUPER_CARD_STATUSES).nullable().default(null),
  supercard_url: z.string().default(''),
  switch_channel_partner_url: z.string().default(''),
  mode: z.enum(SUPER_CARD_MODES).default('application'),
  ttl: z.preprocess(toNumber, z.number().nullable().default(null)),
  customer_id: z.string().default(''),
  activated_driver_count: z.preprocess(
    toNumber,
    z.number().nullable().default(null),
  ),
});
